import LogRocket from 'logrocket';

import MainMarker from 'Images/generic_marker.png';
import BlueMarker from 'Images/generic_blue_marker.png';
import template from './sitePanel.component.html';


/* @ngInject */
function sitePanelController(
  $rootScope,
  $scope,
  $compile,
  $window,
  $element,
  appConfig,
  DashboardService,
  EquipmentInfoService,
  EventInfoService,
  EventsPanelService,
  growl,
  MapService,
  SiteService,
) {
  const vm = this;

  const optLat = 32;
  const optLng = -97;
  const ICON_WIDTH = 25;
  const ANCHOR_LAT = ICON_WIDTH / 2;
  const ICON_HEIGHT = 33;
  const mapOptions = {
    center: new google.maps.LatLng(optLat, optLng),
    zoom: 5,
  };
  const Icons = { main: MainMarker, blue: BlueMarker };

  vm.editPanel = {
    needsToBeConfigured: false
  };


  const markers = {};
  const equipmentObj = {};
  const polygons = [];

  let map;
  let cluster;
  let oms;
  let equipment = [];
  let datInfoBox;

  const ignoredEvents = _.get(EventInfoService, 'eventsConfig.eventPanelExclusions', []);
  const rcuCameraList = {};

  vm.$onInit = init;
  vm.$onDestroy = onDestroy;
  vm.close = close;
  vm.showInfoBox = showInfoBox;
  vm.panel = null;
  vm.currentDashboard = null;
  vm.loadingSpinners = false;
  vm.saveSiteInfo = saveSiteInfo;
  vm.cancelEdit = cancelEdit;
  vm.editableInfo = false;
  vm.editInfo = editInfo;
  vm.site = {};
  vm.addNotificationRecipient = addNotificationRecipient;
  vm.user = appConfig.user;

  async function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    const { siteId } = vm.panel.config;
    if (!siteId) {
      console.error(`${vm.panel.id} is missing a site ID in its config`);
      vm.editPanel.needsToBeConfigured = true;
      return;
    }
    await getSite(siteId);
    equipment = _.filter(await EquipmentInfoService.getFullEquipment(vm.site.equipment), MapService.eqIsMappable);
    if (!equipment) {
      console.error(`${vm.panel.id} has no assigned equipment`);
      vm.editPanel.needsToBeConfigured = true;
      return;
    }
    initMapWatchers();
    $scope.$apply();
    vm.loadingSpinners = true;
    // Programmatically click on site marker
    google.maps.event.trigger(markers[vm.site.id], 'click');
  }

  function initMapWatchers() {
    const mapWatcher = $scope.$watch(() => $element.find('#map_canvas')?.get(0), (element) => {
      if (!element) {
        return;
      }
      mapWatcher();
      map = new MapService.Map(element, `sitepanel-${vm.panelId}`, mapOptions);
      cluster = new MapService.MarkerCluster(map, { gridSize: 25 });
      oms = new MapService.MarkerSpiderfier(map);
      oms.addListener('click', (marker) => {
        setEventsFilter(marker.id);
        showInfoBox(marker.id);
        marker.setAnimation(null);
        marker.setIcon(Icons.main);
      });

      _.forEach(equipment, (eq) => {
        const { id, equipmentType, rcu, settings: { latitude, longitude }, site: siteId } = eq;
        equipmentObj[id] = _.merge(equipmentObj[id], eq);
        eq = equipmentObj[id];
        if (equipmentType === 'cameras') {
          rcuCameraList[rcu] = id;
        }
        if (!latitude || !longitude) {
          return;
        }
        const image = {
          url: Icons.main,
          size: { lat: ICON_WIDTH, lng: ICON_HEIGHT },
          origin: { lat: 0, lng: 0 },
          anchor: { lat: ANCHOR_LAT, lng: ICON_HEIGHT }
        };
        let marker = {};
        if (siteId) {
          if (!markers[siteId]) {
            createSiteMarker(siteId);
          }
          // For all equipment belonging to sites, add an equipment marker
          const equipmentMarker = new MapService.Marker(map,
            eq,
            image,
            false,
            { visible: false }
          );
          oms.addMarker(equipmentMarker);
          markers[id] = equipmentMarker;
        } else {
          marker = new MapService.Marker(null, eq, image);
          cluster.addMarker(marker);
          oms.addMarker(marker);
          markers[id] = marker;
        }

        // new event open stream
        $scope.$on(`event:${id}`, (__, eventObj) => {
          if (!_.includes(ignoredEvents, eventObj.eventName)) {
            const eventMarker = markers[eventObj.equipment.id];
            eventMarker.setAnimation(google.maps.Animation.BOUNCE);
            eventMarker.setIcon(Icons.main);
          }
        });
      });

      EquipmentInfoService.subscribeToGivenEquipment(_.map(equipment, 'id'));
      const markerArr = Object.values(markers);
      MapService.fitZoomMap(map, markerArr);
    });

  }

  async function getSite(siteId) {
    const site = await SiteService.get(siteId);
    vm.site = site;
    if (!vm.site.info?.contacts) {
      migrateOldDataFormat();
    }
  }

  function onDestroy() {
    EquipmentInfoService.unsubscribeToGivenEquipment(_.map(equipment, 'id'));
    cluster.setMap(null);
    oms.clearMarkers();
    oms.clearListeners('click');
    MapService.unsetMarkers(Object.values(markers));
    polygons.forEach(polygon => polygon.setMap(null));
    MapService.destroyGoogleMaps('#map_canvas');
  }

  /**
   * Close all info windows when user opens another or clicks the close button
   *
   * @param {boolean} [newTarget=false] If another window will be opened
   */
  function close(newTarget) {
    if (datInfoBox) {
      $(datInfoBox.getContent()).remove();
      MapService.removeIntervalsAndCloseInfoWins(datInfoBox);
      datInfoBox = undefined;
    }
    // Only clear the filter when new window was not opened somewhere else
    !newTarget && setEventsFilter();
  }

  function showInfoBox(idEquipment) {
    close(true);

    if (_.has(equipmentObj, `${idEquipment}.infowindow`)) {
      equipmentObj[idEquipment].infowindow.close();
      if (equipmentObj[idEquipment].timeout) {
        equipmentObj[idEquipment].timeout = null;
      }
    }
    EquipmentInfoService.getEquipmentById(idEquipment)
      .then((eq) => {
        let dashboard = '';
        if (eq.dashboards && eq.dashboards.length > 0) {
          dashboard = eq.dashboards[0].id;
        }

        const contentEquip = new ContentEquip(eq);
        if (datInfoBox) {
          datInfoBox.setContent(new MapService.CameraContentBox(contentEquip, '$ctrl', dashboard));
        } else {
          datInfoBox = createInfoBox(contentEquip, dashboard);
        }
        $compile(datInfoBox.content_)($scope);

        const marker = markers[idEquipment];

        vm.activeCameraId = datInfoBox.cameraId;
        datInfoBox.open(map, marker);
        // workaround until google fixes their shit: https://issuetracker.google.com/issues/111997760
        setTimeout(() => {
          datInfoBox.content_.parentNode.parentNode.parentNode.style.width = '100%';
        }, 100);
      });
  }

  function createInfoBox(eq, dash) {
    // create different popups based on equipment type.
    const box = new MapService.CameraContentBox(eq, '$ctrl', dash);

    const minCompare = 337;
    const multiByWidth = 0.7;
    const height = Math.min(parseInt($window.innerWidth * multiByWidth, 10), minCompare);
    const divByHeight = 2;
    const negPix = -35;
    const pixsOff = -400;

    return new MapService.Infobox(
      eq.id,
      {
        content: box,
        boxStyle: {
          height: `${height}px`
        },
        pixelOffset: new google.maps.Size(pixsOff / divByHeight, negPix),
        zIndex: 100_000, // has to be high to give room to the infowindow's zIndex
        enableEventPropagation: false
      }
    );
  }

  function createSiteMarker(siteId) {
    // Prevent creating any site icons that have lat/lng 0,0 or old unconfigured sites without lat/lng (null)
    if (vm.site.border === null) {
      return void LogRocket.captureException(new Error('Site with null border'), {
        extra: { site: vm.site.id }
      });
    }
    const blueImage = {
      url: Icons.blue,
      size: { lat: ICON_WIDTH, lng: ICON_HEIGHT },
      origin: { lat: 0, lng: 0 },
      anchor: { lat: ANCHOR_LAT, lng: ICON_HEIGHT }
    };
    // MapService is expecting lat & long to live in settings like equipment
    vm.site.settings = {
      latitude: vm.site.latitude,
      longitude: vm.site.longitude
    };
    const siteMarker = new MapService.Marker(map, vm.site, blueImage, false, { zIndex: 1 });
    const polygon = new MapService.Polygon(map, vm.site.border, false);
    const zoomAroundPolygon = MapService.getBoundsZoomLevel(polygon.getBounds());
    const bounds = new google.maps.LatLngBounds();

    // Add a listener to the site marker that zooms and toggles marker visibility
    siteMarker.addListener('click', () => {
      siteMarker.setVisible(false);
      _.forEach(equipment, ({ id }) => {
        if (markers[id]) {
          markers[id].setVisible(true);
          bounds.extend(markers[id].position);
        }
      });
      zoomAroundPolygon <= MapService.getBoundsZoomLevel(bounds) ? // zoom to what is further out
        map.fitBounds(bounds) :
        map.fitBounds(polygon.getBounds());
    });
    google.maps.event.addListener(map, 'zoom_changed', () => {
      const zoom = map.getZoom(); // Is there better way than a zoom listener for each site?
      const isVisible = zoom <= (zoomAroundPolygon - 3); // sweet spot to flip between marker and polygon
      siteMarker.setVisible(isVisible);
      polygon.setVisible(!isVisible);
      _.forEach(equipment, ({ id }) => {
        if (markers[id]) {
          markers[id].setVisible(!isVisible);
          bounds.extend(markers[id].position);
        }
      });
    });
    polygons.push(polygon); // save this polygon so we can remove all from map later
    markers[siteId] = siteMarker;
  }

  function ContentEquip(eq) {
    const camId = eq.equipmentType === 'cameras' ? eq.id : rcuCameraList[eq.rcu];
    return {
      name: eq.name,
      id: camId
    };
  }

  function migrateOldDataFormat() {
    vm.site.info = _.transform(vm.site.info, (result, value, key) => {
      if (key.toLowerCase().includes('contact')) {
        const contact = key.toLowerCase().split('contact')[0];
        const contactField = key.toLowerCase().split('contact')[1];
        const contactIdx = (result.contacts || (result.contacts = [])).findIndex(cont => cont.type === contact);
        if (contactIdx > -1) {
          result.contacts[contactIdx] = { ...result.contacts[contactIdx], [contactField]: value };
        } else {
          result.contacts.push({ type: contact, [contactField]: value });
        }
      } else {
        result[key] = value;
      }
    }, {});
    saveSiteInfo();
  }

  function editInfo() {
    vm.editableInfo = !vm.editableInfo;
    const defaultContacts = {
      contacts: [
        {
          type: 'primary',
          name: '',
          phone: '',
          email: ''
        },
        {
          type: 'alternate',
          name: '',
          phone: '',
          email: ''
        },
        {
          type: 'contingent',
          name: '',
          phone: '',
          email: ''
        },
        {
          type: 'emergency',
          name: '',
          phone: '',
          email: ''
        }
      ]
    };
    _.defaultsDeep(vm.site.info, defaultContacts);
  }

  async function saveSiteInfo() {
    const msg = growl.info('Saving site info...', { disableCloseButton: true });
    try {
      await SiteService.update(vm.panel.config.siteId, JSON.parse(angular.toJson(vm.site)));
      vm.editableInfo = false;
      growl.success('Site info saved');
    } catch ({ error }) {
      growl.error(error, { title: 'Error Saving Site Info:' });
    }
    msg.destroy();
  }

  async function cancelEdit() {
    getSite(vm.panel.config.siteId);
    vm.editableInfo = false;
  }

  async function setEventsFilter(eqId) {
    const targetPanel = _.find(vm.currentDashboard.panels, { type: 'events' });
    if (!targetPanel) {
      return;
    }
    const setFilter = eqId ?
      EventsPanelService.setFilter(targetPanel.id, { equipment: [eqId] }) :
      EventsPanelService.clearFilter(targetPanel.id, false);
    setFilter.then(() => $rootScope.$emit('equipment-selected'));
  }

  async function addNotificationRecipient() {
    if (!vm.site.info.notificationList) {
      vm.site.info.notificationList = [];
    }
    vm.site.info.notificationList.push({
      name: '',
      email: ''
    });
  }
}

export default {
  name: 'sitePanel',
  template,
  controller: sitePanelController,
  bindings: {
    panelId: '<'
  }
};
